import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailers-add_new_shipping_address_complete-action_unknown';
/**
 * track when retailer completes add new shipping address
 */
export function trackRetailersAddNewShippingAddressComplete(retailer_token, pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'retailer-add-new-address',
        googleTagManagerEvent: 'retailer-add-new-address',
        pixelCustomDataParams: pixelCustomDataParams,
        parameters: { retailer_token },
    });
}
